/* uhren4you · Kategorie- und Suchseite (31.10.2026)
   Filterfenster öffnen/schließen, Trefferzahl live, Sortierung, feste Leiste auf dem Handy,
   „Zuletzt angesehen“ (aus dem Browser), „Beliebt in …“ (meistverkaufte Produkte), mehr Kategorien. */
(function () {
  'use strict';
  if (window.u4yPlpReady) return;
  window.u4yPlpReady = true;
  var d = document, root = d.documentElement;
  var drawer = d.getElementById('u4y-drawer');
  var ov = d.querySelector('.u4y-ov');
  var lastBtn = null;

  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }

  function openDrawer(param, btn) {
    if (!drawer) return;
    lastBtn = btn || null;
    drawer.hidden = false;
    if (ov) ov.hidden = false;
    root.classList.add('u4y-lock');
    d.querySelectorAll('[data-u4y-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var target = param ? drawer.querySelector('details[data-param="' + esc(param) + '"]') : null;
    setTimeout(function () {
      if (target) {
        target.open = true;
        target.scrollIntoView({ block: 'start' });
        var s = target.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      } else {
        var c = drawer.querySelector('.u4y-close');
        if (c) c.focus({ preventScroll: true });
      }
    }, 30);
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    if (ov) ov.hidden = true;
    root.classList.remove('u4y-lock');
    d.querySelectorAll('[data-u4y-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastBtn) lastBtn.focus();
  }

  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-u4y-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-u4y-open'), o); return; }
    var c = e.target.closest('[data-u4y-close]');
    if (c) { e.preventDefault(); closeDrawer(); return; }
    var m = e.target.closest('[data-u4y-more]');
    if (m) {
      var list = m.closest('[data-u4y-chips]');
      if (list) {
        list.classList.add('is-open');
        var li = m.closest('li');
        var first = list.querySelector('li.is-more a');
        if (li) li.remove();
        if (first) first.focus();
      }
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && drawer && !drawer.hidden) {
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary');
      var vis = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!vis.length) return;
      var a = vis[0], z = vis[vis.length - 1];
      if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* Trefferzahl im Filterfenster */
  var form = d.querySelector('[data-u4y-form]');
  var showBtn = d.querySelector('[data-u4y-show]');
  var timer = null, reqNo = 0;
  function formParams() {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p;
  }
  function updateCount() {
    if (!form || !showBtn) return;
    var p = formParams();
    p.delete('sort_by'); p.delete('page');
    p.set('section_id', form.getAttribute('data-sec') || 'u4y-count');
    var my = ++reqNo;
    fetch(form.getAttribute('action') + '?' + p.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (my !== reqNo || !html) return;
        var m = html.replace(/<[^>]+>/g, ' ').match(/\d+/);
        if (!m) return;
        var n = parseInt(m[0], 10);
        var tpl = showBtn.getAttribute('data-tpl') || '[n]';
        showBtn.textContent = tpl.replace('[n]', n.toLocaleString(root.lang || 'de'));
        showBtn.disabled = n === 0;
      })
      .catch(function () {});
  }
  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      /* zusammengefasste Werte: versteckte Zwillinge mitnehmen */
      if (t.type === 'checkbox' && !t.hasAttribute('data-u4y-twin')) {
        var box = t.closest('.u4y-opt');
        if (box) box.querySelectorAll('input[data-u4y-twin]').forEach(function (x) { x.checked = t.checked; });
      }
      if (t.name === 'sort_by' || t.matches('[data-u4y-find]')) return;
      clearTimeout(timer); timer = setTimeout(updateCount, 250);
    });
    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-u4y-find]')) {
        var q = t.value.trim().toLowerCase();
        t.parentNode.querySelectorAll('.u4y-opt').forEach(function (l) {
          l.classList.toggle('is-hidden', q !== '' && l.textContent.toLowerCase().indexOf(q) < 0);
        });
      } else if (t.type === 'number') {
        clearTimeout(timer); timer = setTimeout(updateCount, 600);
      }
    });
    form.addEventListener('submit', function () {
      form.querySelectorAll('input').forEach(function (i) {
        if (i.matches('[data-u4y-find]')) { i.disabled = true; return; }
        if (i.type === 'number' && i.value.trim() === '') i.disabled = true;
      });
    });
  }

  /* Sortierung in der Leiste */
  var sel = d.querySelector('[data-u4y-sort]');
  if (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  }

  /* feste Leiste unten auf dem Handy, sobald die Filterleiste aus dem Bild ist */
  var bar = d.querySelector('[data-u4y-fbar]');
  var sticky = d.querySelector('[data-u4y-sticky]');
  if (bar && sticky && 'IntersectionObserver' in window) {
    var mq = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.hidden = !(mq.matches && past);
      d.body.classList.toggle('u4y-fsticky-on', !sticky.hidden);
    }).observe(bar);
  }

  /* Zuletzt angesehen */
  var rec = d.querySelector('[data-u4y-recent]');
  if (rec) {
    try {
      var items = JSON.parse(localStorage.getItem('u4y_recent') || '[]');
      if (Array.isArray(items) && items.length) {
        var ul = rec.querySelector('[data-u4y-recent-list]');
        items.slice(0, 6).forEach(function (x) {
          if (!x || !x.u) return;
          var li = d.createElement('li');
          var a = d.createElement('a');
          a.className = 'u4y-rc';
          a.href = x.u;
          if (x.i) {
            var img = d.createElement('img');
            img.src = x.i; img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 96;
            a.appendChild(img);
          }
          var box = d.createElement('span');
          var b = d.createElement('b');
          b.textContent = (x.b ? x.b + ' · ' : '') + (x.t || '');
          var p = d.createElement('span');
          p.textContent = x.p || '';
          box.appendChild(b); box.appendChild(p);
          a.appendChild(box);
          li.appendChild(a);
          ul.appendChild(li);
        });
        if (ul.children.length) rec.hidden = false;
      }
    } catch (err) {}
  }

  /* Große Bestseller-Kachel: bei jedem Seitenaufruf ein anderes meistverkauftes Produkt der Kategorie (01.11.2026) */
  var hero = d.querySelector('[data-u4y-hero]');
  if (hero) {
    var heroDrop = function () { if (hero.parentNode) hero.parentNode.removeChild(hero); };
    fetch(hero.getAttribute('data-u4y-hero'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = d.createElement('div');
        tmp.innerHTML = html || '';
        var items = Array.prototype.slice.call(tmp.querySelectorAll('[data-u4y-hero-list] > li'));
        if (!items.length) { heroDrop(); return; }
        var key = 'u4y_hero_' + location.pathname, last = '';
        try { last = sessionStorage.getItem(key) || ''; } catch (err) {}
        var pool = items.length > 1 ? items.filter(function (li) { return li.getAttribute('data-hero') !== last; }) : items;
        if (!pool.length) pool = items;
        var pick = pool[Math.floor(Math.random() * pool.length)];
        var url = pick.getAttribute('data-hero') || '';
        try { sessionStorage.setItem(key, url); } catch (err) {}
        hero.parentNode.replaceChild(pick, hero);
        /* dasselbe Produkt nicht noch einmal als kleine Karte zeigen */
        d.querySelectorAll('#u4y-plp .u4y-grid > li:not(.u4y-gi--promo) a.u4y-card').forEach(function (a) {
          var h = (a.getAttribute('href') || '').split('?')[0];
          if (url && h === url) { var li = a.closest('li'); if (li) li.parentNode.removeChild(li); }
        });
      })
      .catch(heroDrop);
  }

  /* Beliebt in der Kategorie */
  var best = d.querySelector('[data-u4y-best]');
  if (best) {
    fetch(best.getAttribute('data-u4y-best'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var list = tmp.querySelector('.u4y-row');
        if (list && list.children.length >= 2) {
          best.querySelector('[data-u4y-best-list]').appendChild(list);
          best.hidden = false;
        }
      })
      .catch(function () {});
  }
})();
